import React from 'react';
import Loadable from 'react-loadable';
import Loader from '../../../utils/Loader';

const InitializationLoadable = Loadable({
    loader: () => import('../index'),
    loading() {
        return <Loader logo />;
    },
});

export default InitializationLoadable;
